import { APIRoute } from '@/modules/utils'
import { Review } from '@/dataV3/Review/Review'

export const Route = (): APIRoute => ({
  method: 'POST',
  path: '/v3/reviews/internal',
})

export type Body = { to: string; content: string; rating: number; careId?: string }

export type Response = Review
